import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
    defaultOptions: {

        queries: {
            staleTime: 0,
            retry: false,
            refetchOnMount: true,
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,

        }
    }
})